(function () {
  "use strict";

  var reinsertTimeout = null;

  function correctPolishPlurals() {
    var sections = document.querySelectorAll(".tuya-judgeme-reviews");
    sections.forEach(function (section) {
      var widget = section.querySelector(
        ".jdgm-widget, .jdgm-review-widget, .jm-review-widget",
      );
      if (!widget) return;

      var singular = section.getAttribute("data-text-singular");
      var plural234 = section.getAttribute("data-text-plural-234");
      var pluralOther = section.getAttribute("data-text-plural-other");

      var targets = widget.querySelectorAll(
        ".jdgm-rev-widg__summary-text, .jdgm-prev-badge__text, .jm-text, [class*='summary-text'], [class*='review-count']"
      );
      targets.forEach(function (el) {
        if (el.closest(".jdgm-rev, .jdgm-review-card, .jdgm-rev-card")) return;

        var text = el.textContent.trim();
        if (isNaN(Number(text))) {
          var num = parseInt(text, 10);
          if (!isNaN(num)) {
            var lastDigit = num % 10;
            var lastTwoDigits = num % 100;
            var correctWord = pluralOther;

            if (num === 1) {
              correctWord = singular;
            } else if (lastTwoDigits >= 12 && lastTwoDigits <= 14) {
              correctWord = pluralOther;
            } else if (lastDigit >= 2 && lastDigit <= 4) {
              correctWord = plural234;
            }

            el.textContent = num + " " + correctWord;
          }
        }
      });
    });
  }

  function reinsertTuyaStyles() {
    if (!document.head) return;

    var tuyaLink = document.querySelector(
      'link[href*="tuya-judgeme-reviews.css"]',
    );
    if (!tuyaLink) return;

    var clone = tuyaLink.cloneNode(true);
    if (tuyaLink.parentNode) {
      tuyaLink.parentNode.removeChild(tuyaLink);
    }
    document.head.appendChild(clone);
  }

  function debouncedReinsert(delay) {
    if (reinsertTimeout) clearTimeout(reinsertTimeout);
    reinsertTimeout = setTimeout(reinsertTuyaStyles, delay || 150);
  }

  function initObservers() {
    var sections = document.querySelectorAll(".tuya-judgeme-reviews");

    sections.forEach(function (section) {
      var widget = section.querySelector(".jdgm-widget, .jdgm-review-widget");
      if (!widget) return;

      if (widget.dataset.tuyaObserved === "true") {
        correctPolishPlurals();
        return;
      }
      widget.dataset.tuyaObserved = "true";

      var hasReinserted = false;
      var debounceTimer = null;

      var observer = new MutationObserver(function () {
        if (debounceTimer) clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function () {
          if (!hasReinserted) {
            reinsertTuyaStyles();
            hasReinserted = true;
          }
          correctPolishPlurals();
        }, 300);
      });

      observer.observe(widget, {
        childList: true,
        subtree: true,
      });

      correctPolishPlurals();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initObservers);
  } else {
    initObservers();
  }

  if (document.head) {
    var headObserver = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (
            node.nodeType === 1 &&
            (node.tagName === "STYLE" || node.tagName === "LINK") &&
            node.textContent &&
            (node.textContent.indexOf("jdgm") !== -1 ||
              (node.href && node.href.indexOf("judge") !== -1))
          ) {
            debouncedReinsert(100);
            return;
          }
        }
      }
    });

    headObserver.observe(document.head, { childList: true });
  }

  document.addEventListener("shopify:section:load", function (e) {
    if (
      e.target &&
      e.target.querySelector &&
      e.target.querySelector(".tuya-judgeme-reviews")
    ) {
      setTimeout(initObservers, 500);
    }
  });
})();
